
import FooterColumn from './FooterColumn.vue'

export default {
  components: { FooterColumn },
  props: { links: { type: Array, default: () => [] } },
}
